<template>
  <list-layout :title="$t('distribution_cycles') | capitalize" :count="count">
    <template v-slot:table>
      <v-server-table
        :columns="columns"
        :options="options"
        ref="distributionCycles"
        @loaded="onLoaded"
        @pagination="onPagination"
      >
        <!-- Name -->
        <template v-slot:name="{ row }">
          <span :class="isMember && !row.hasReports ? 'text-gray' : ''">{{ row.name }}</span>
          <div v-if="isAdmin && row.distributions">
              <div
                v-for="(distribution, index) in row.distributions"
                :key="distribution.code+index"
                class="text-gray ml-3"
              >
                <div class="b-row d-flex">
                  <div class="b-col px-2">{{ distribution.code }}</div>
                  <div class="b-col ml-2">{{ distribution.name }}</div>
                </div>
              </div>
            </div>
        </template>

        <!-- ID -->
        <template v-slot:id="{ row }">
          <div v-if="isAdmin" class="text-gray">{{ row.id }}</div>
        </template>

        <!-- Published Date -->
        <template v-slot:publishedDate="{ row }">
          <date-time-cell :dateTime="row.publishedDate" />
        </template>

        <!-- Actions -->
         <template v-slot:actions="{ row }">
          <div class="d-flex flex-row justify-content-center align-items-center">
            <action
              v-if="isMember && row.hasMemberReports && row.publishedDate"
              :title="$t('member_reports_download')"
              @click="onDownloadMemberReport(row)"
              :icon="['fas', 'file-download']"
            />
            <action
              v-if="isAdmin && row.hasQaReports"
              :title="$t('download_aggregate_member_finance')"
              @click="onDownloadQaReport(row)"
              :icon="['fas', 'file-download']"
            />
          </div>
        </template>
      </v-server-table>
    </template>
  </list-layout>
</template>

<style lang="scss" scoped>
  .gray {
    color: var(--muted-gray);
  }
</style>

<script>
import { mapGetters, mapMutations } from "vuex"
import { clickOnUrl } from "@/services/utils"
import { get } from "lodash"
import { listRouteMixin } from "@/utils/mixins"
import { startCase } from "@/utils/filters"


export default {
  name: "DistributionsCyclesList",
  mixins: [listRouteMixin],
  data () {
    return {
      count: 0,
      options: {
        headings: {
          name: startCase(this.$t("name")),
          id: "ID",
          publishedDate: startCase(this.$t("published_date")),
          actions: "",
        },
        responseAdapter ({ data }) {
          return {
            data: data.results,
            count: data.count,
          }
        },
        requestFunction (queryParams) {
          queryParams = { ...queryParams, ...this.$route.query }
          this.page = Number(get(queryParams, "page", 1))
          return this.$api.distributions.distributionCycleList(queryParams)
        }
      },
    }
  },
  computed: {
    ...mapGetters("user", ["isAdmin", "isMember"]),
    columns () {
      const memberColumns = ["name", "publishedDate", "actions"]
      const adminColumns = ["name", "id", "publishedDate",  "actions"]
      return this.isMember ? memberColumns : adminColumns
    }
  },
  methods: {
    ...mapMutations("alert", ["success", "error"]),
    getData () {
      this.$refs.distributionCycles.getData()
    },
    onLoaded ({ data }) {
      this.count = data.count
    },
    onDownloadMemberReport (row) {
      this.$api.distributions.distributionCycleDownloadMembersReport(row.id)
        .then(({ data }) => {
          if (data.url) clickOnUrl(data.url)
          else this.success(this.$t("request_sent"))
        })
        .catch((err) => {
          let message = err.response.data?.message || err.response.data || err.response
          this.error(message)
        })
    },
    onDownloadQaReport (row) {
      this.$api.distributions.distributionCycleDownloadQaReports(row.id)
        .then(({ data }) => {
          if (data.url) clickOnUrl(data.url)
          else this.success(this.$t("request_sent"))
        })
        .catch((err) => {
          let message = err.response.data?.message || err.response.data || err.response
          this.error(message)
        })
    },
  }
}
</script>
